import "./TimeTrackerOverviewTable.css";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import userTypeConsts from "../../../constants/userTypeConsts";
import { formatEntryDay } from "../../../utils/tenantDate";

const TimeTrackerOverviewPrintTable = (props) => {
  const [data, setData] = useState(props.timerData);
  const tracker = useSelector((state) => state.tracker);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const userType = props.user.userType;
  
  // Calculate column count based on user type (User, Tasks, Client, Project, Sprint, Tag, Duration, Date, Billable)
  const columnCount = (userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN) ? 9 : 8;

  useEffect(() => {
    const getTableData = async () => {
      setIsTableLoading(true);
      try {
        setData(props.timerData);
      } catch (err) {
        global.config.slackMessage(err.toString());
        console.log(err);
      }
      setIsTableLoading(false);
    }
    getTableData();
  }, [props.timerData, tracker]);

  const chnageDurationFormat = (sec) => {
    let second = sec;
    const hours = Math.floor(second / 3600);
    const minutes = Math.floor((second % 3600) / 60);
    const seconds = second % 60;
    const formattedDuration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    return formattedDuration;
  }
  return (
    <div className="outer-time-table" style={{ 
      width: "100%",
      overflow: "visible"
    }}>
      <div className="time-table" style={{
        width: "100%",
        maxWidth: "100%",
        overflow: "visible",
        marginTop: "0"
      }}>
        <table style={{
          width: "100%",
          tableLayout: "fixed",
          borderCollapse: "collapse"
        }}>
          <thead>
            <tr>
              {(userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN) &&
                (<><th style={{ width: "12%" }}>
                  User
                </th></>)}
              <th style={{ width: userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN ? "14%" : "16%" }}>
                Tasks
              </th>
              <th style={{ width: userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN ? "12%" : "14%" }}>
                Client
              </th>
              <th style={{ width: userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN ? "12%" : "14%" }}>
                Project
              </th>
              <th style={{ width: userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN ? "10%" : "12%" }}>
                Sprint
              </th>
              <th style={{ width: userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN ? "8%" : "10%" }}>
                Tag
              </th>
              <th style={{ width: userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN ? "8%" : "10%" }}>
                Duration
              </th>
              <th style={{ width: userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN ? "12%" : "14%" }}>
                Date
              </th>
              <th style={{ width: userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN ? "8%" : "10%" }}>
                Billable
              </th>
            </tr>
          </thead>
          <tbody>
            {isTableLoading ? (
              <>
                {Array.from({ length: 5 }).map((_, index) => (
                  <tr key={`skeleton-${index}`}>
                    {(userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN) && (
                      <td>
                        <div className="extra-detail">
                          <div className="member-name">
                            <div
                              className="member-image"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                backgroundColor: "#e5e7eb",
                                animation: "pulse 1.5s ease-in-out infinite",
                                flexShrink: 0,
                              }}
                            />
                            <span
                              style={{
                                width: "120px",
                                height: "18px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                                display: "block",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    )}
                    <td>
                      <div
                        style={{
                          width: "120px",
                          height: "18px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </td>
                    <td>
                      <div
                        style={{
                          width: "140px",
                          height: "18px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </td>
                    <td>
                      <div
                        style={{
                          width: "70px",
                          height: "18px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </td>
                    <td>
                      <div
                        style={{
                          width: "140px",
                          height: "18px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </td>
                    <td>
                      <span
                        className="yes"
                        style={{
                          backgroundColor: "#e5e7eb",
                          border: "none",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      >
                        <div
                          style={{
                            width: "30px",
                            height: "12px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "2px",
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </>
            ) : data.length > 0 ? (
              data.map((row, index) => (
                <tr key={index}>
                  {(userType === userTypeConsts.SUPER_ADMIN || userType === userTypeConsts.ADMIN) &&
                    (<>
                      <td>
                        <div className="member-name">
                          <img
                            src={`/uploads/lowProfileImage/${row.user && row.user.profile_image}`}
                            alt={row.user && row.user.first_name}
                            className="member-image"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = '/uploads/lowProfileImage/user_default.png';
                            }}
                          />
                          <span>{row.user.first_name ? (
                            <>
                              {row.user.first_name}{" "}
                              {row.user.middle_name &&
                                row.user.middle_name !== "null"
                                ? row.user.middle_name + " "
                                : ""}
                              {row.user.last_name}{" "}
                            </>
                          ) : (
                            <>
                              {row.user.company_first_name
                                ? `${row.user.company_first_name} ${row.user.company_last_name ? row.user.company_last_name : ''}`
                                : `${row.user.company_name || ''}(Company)`
                              }
                            </>
                          )}</span>
                        </div>
                      </td></>)}
                  <td>{row.task !== null && row.task !== undefined ? row.task : "--"}</td>
                  <td>{row?.project?.client_name !== null && row?.project?.client_name?.client_name}</td>
                  <td>{row?.project?.project_name}</td>
                  <td>{row?.sprint?.sprint_name && row?.sprint?.sprint_name !== null ? row.sprint.sprint_name : "--"}</td>
                  <td>{row?.tag?.tag_name && row?.tag?.tag_name !== null ? row.tag.tag_name : "--"}</td>
                  <td>{chnageDurationFormat(row.duration)}</td>
                  <td>{formatEntryDay(row)}</td>
                  <td>
                    <span className={row?.project?.is_billable === true ? "yes" : "no"}>
                      {row?.project?.is_billable ? "Yes" : "No"}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columnCount} style={{ textAlign: "center", padding: "20px" }}>
                  No Results
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Pulse animation style and Print styles */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
        
        @media print {
          * {
            box-sizing: border-box !important;
          }
          
          body {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
          }
          
          .outer-time-table {
            width: 100% !important;
            max-width: 100% !important;
            overflow: visible !important;
            margin: 0 !important;
            padding: 0 !important;
            display: block !important;
          }
          
          .time-table {
            width: 100% !important;
            max-width: 100% !important;
            overflow: visible !important;
            border-radius: 0 !important;
            box-shadow: none !important;
            margin: 0 !important;
            padding: 0 !important;
            border: none !important;
            display: block !important;
          }
          
          .time-table table {
            width: 100% !important;
            max-width: 100% !important;
            table-layout: fixed !important;
            border-collapse: collapse !important;
            overflow: visible !important;
            white-space: normal !important;
            display: table !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          
          .time-table thead {
            display: table-header-group !important;
          }
          
          .time-table tbody {
            display: table-row-group !important;
          }
          
          .time-table tr {
            display: table-row !important;
            page-break-inside: avoid !important;
          }
          
          .time-table th,
          .time-table td {
            padding: 6px 8px !important;
            white-space: normal !important;
            word-wrap: break-word !important;
            overflow-wrap: break-word !important;
            font-size: 11px !important;
            line-height: 1.3 !important;
            display: table-cell !important;
            vertical-align: middle !important;
            border: 1px solid #d8dde1 !important;
          }
          
          .time-table th {
            background-color: #f5f6f8 !important;
            font-weight: 600 !important;
            border-bottom: 2px solid #d8dde1 !important;
            text-align: left !important;
          }
          
          .time-table td {
            border-bottom: 1px solid #d8dde1 !important;
            text-align: left !important;
          }
          
          .time-table .member-name {
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
            flex-wrap: nowrap !important;
          }
          
          .time-table .member-image {
            width: 28px !important;
            height: 28px !important;
            flex-shrink: 0 !important;
            object-fit: cover !important;
          }
          
          .time-table .member-name span {
            font-size: 11px !important;
            white-space: normal !important;
            word-wrap: break-word !important;
            overflow-wrap: break-word !important;
            flex: 1 !important;
          }
          
          .time-table .yes,
          .time-table .no {
            font-size: 10px !important;
            padding: 3px 6px !important;
            width: auto !important;
            min-width: 40px !important;
            display: inline-flex !important;
            justify-content: center !important;
            align-items: center !important;
          }
          
          @page {
            size: A4 landscape;
            margin: 10mm 5mm;
          }
        }
      `}</style>
    </div>
  );
};

export default TimeTrackerOverviewPrintTable;